import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute } from '@angular/router';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { filter, Observable, Subscription } from 'rxjs';
import { selectCurrentDevice, selectCurrentDeviceLoading, selectCurrentDeviceModel } from 'src/app/store/device/device.selector';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { Lang } from 'src/app/model/lang';
import { Device } from 'src/app/model/device';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { Site } from 'src/app/model/site';
import * as SiteActions from 'src/app/store/site/site.actions';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { DeviceModel } from 'src/app/model/device-model';

@Component({
	selector: 'app-device',
	templateUrl: './device.component.html',
	providers: [],
})

export class DeviceComponent implements OnInit, OnDestroy {
	loading$: Observable<boolean | undefined>;
	loadingSub: Subscription | undefined;
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;

	currentLang: Lang;
	device: Device;
	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;

	deviceModel: DeviceModel;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;

	loading: boolean;
	currentSite: Site;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.store.dispatch(DeviceActions.acquireBoardUserResetDialog());
		this.store.dispatch(DeviceActions.getNewDeviceModels({}));
		this.store.dispatch(DeviceActions.getAutomationsText());
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'DEVICE'
		}));
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		// Store selectors
		this.loading$ = this.store.select(selectCurrentDeviceLoading);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.device$ = this.store.select(selectCurrentDevice);
		this.site$ = this.store.select(selectCurrentSite);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
	}

	subscribeAll(): void {
		this.route.params?.subscribe(params => {
			if (params['deviceId']) {
				this.store.dispatch(DeviceActions.getCurrentDevice({ deviceId: params['deviceId'] }));
			}
		});
		this.loadingSub = this.loading$?.subscribe(
			(loading) => {
				this.loading = loading;
			}
		);
		this.currentLangSub = this.currentLang$?.subscribe(lang => {
			this.currentLang = lang;
			if (this.device !== undefined && this.device !== null) {
				this.store.dispatch(DeviceActions.getDeviceModel({ modelId: this.device.ModelId, language: lang.code }));
				this.store.dispatch(DeviceActions.getCommands({ device: this.device }));
				this.store.dispatch(DeviceActions.getAutomationsText());
			}
		});
		this.deviceSub = this.device$?.subscribe(
			(device) => {
				if (device !== undefined && device !== null) {
					this.device = device;
					if (this.currentLang !== undefined && this.currentLang !== null) {
						this.store.dispatch(DeviceActions.getDeviceModel({ modelId: this.device.ModelId, language: this.currentLang.code }));
						this.store.dispatch(DeviceActions.getCommands({ device: this.device }));
					}
				}
			}
		);
		this.siteSub = this.site$.subscribe(currentSite => {
			this.currentSite = currentSite;
			this.checkCurrentSite();
		});
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
				// console.log(this.deviceModel)
			});
	}

	checkCurrentSite(): void {
		if (this.device !== undefined && this.device !== null &&
			this.currentSite !== undefined && this.currentSite !== null &&
			this.device.SiteId !== undefined && this.currentSite.Id !== undefined &&
			this.device.SiteId !== this.currentSite.Id) {
			this.store.dispatch(SiteActions.setCurrentSite({ siteId: this.device.SiteId }));
		}
	}

	ngOnDestroy(): void {
		this.loadingSub?.unsubscribe();
		this.currentLangSub?.unsubscribe();
		this.deviceSub?.unsubscribe();
		this.siteSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}
